<template>
   <div>
     <div class="search_unit">
       <div style='display:inline-block;'>
          <el-date-picker
          v-model="yearmonth"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择开始(必选)">
        </el-date-picker>
        <el-date-picker
          v-model="yearmonth2"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择结束(必选)">
        </el-date-picker>
          <el-select v-model="drughospital" clearable  filterable  placeholder="医院(可选)">
            <el-option
              v-for="item in hospitallist"
              :key="item.id"
              :label="item.name"  
              :value="item.name"
               
              >
            </el-option>
          </el-select>
        </div>
        <div style='display:inline-block;'>
          <el-select v-model="drugcode" clearable filterable  placeholder="药名(可选)">
            <el-option
              v-for="item in druglist"
              :key="item.id"
              :label="item.drugname+'/'+item.drugspec+'/'+item.drugcode"  
              :value="item.drugcode"
               
              >
            </el-option>
          </el-select>
        </div>
        <div style='display:inline-block;'>
          <el-select v-model="drugfactory" clearable filterable  placeholder="药厂(可选)">
            <el-option
              v-for="item in factorylist"
              :key="item.id"
              :label="item.name"  
              :value="item.name"
               
              >
            </el-option>
          </el-select>
        </div>
        <div style='display:inline-block;'>
          <el-select v-model="drugsalecorp" clearable filterable  placeholder="商业公司(可选)">
            <el-option
              v-for="item in salecorplist"
              :key="item.id"
              :label="item.name"  
              :value="item.name"
               
              >
            </el-option>
          </el-select>
        </div>
        <div style='display:inline-block;'>
          <el-select v-model="matchtype" clearable placeholder="匹配状态(可选)">
             <el-option label="未匹配"  :value="0"> </el-option>
             <el-option label="已匹配"  :value="1"> </el-option>
          </el-select>
        </div>
        <div style='display:inline-block;'>
          <el-input placeholder="蜜蜂名/医院名" v-model="keywords" class="input-with-select" @change='getList()'>
            <el-button type="primary" slot="append" icon="el-icon-search" @click='getList()' >筛选数据</el-button>
          </el-input>
        </div>
        <div style='display:block;margin-top:5px;'>
          <el-button type="success" icon="el-icon-check" @click="goMatch" size="small">执行匹配</el-button>
          <el-button type="info" icon="el-icon-download" @click="downSourceDialogVisible = true" size="small">导出全部数据</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="batchDelete" size="small">批量删除</el-button>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="reciptno"
        label="单据号"
        >
      </el-table-column>
      <el-table-column
        label="日期"
        >
        <template slot-scope="scope"> 
           {{scope.row.reporttime | timeToDate2}}
      </template>
      </el-table-column>
    
      <el-table-column
        prop="drughospital"
        label="医院名称"
        >
      </el-table-column>
      <el-table-column
        prop="drugfactory"
        label="药厂"
        >
      </el-table-column>
      <el-table-column
        prop="drugsalecorp"
        label="商业公司"
        >
      </el-table-column>
      <el-table-column
        prop="drugname"
        label="药名"
      >
      </el-table-column>
      <el-table-column
        prop="drugspec"
        label="规格"
      >
      </el-table-column>
      <el-table-column
        prop="nums"
        label="数量"
      >
      </el-table-column>
      <el-table-column
        prop="price"
        label="单价"
      >
      </el-table-column>
      <el-table-column
        prop="drugterminal"
        label="配送站"
      >
      </el-table-column>
      <el-table-column
        label="蜜蜂1"
        >
        <template slot-scope="scope"> 
           <div>{{ scope.row.bee1 }}</div>
           <div v-if="scope.row.bee1!=''&&!needhide">{{ scope.row.commission1 }}元/盒</div>
        </template>
      </el-table-column>
      <el-table-column
        label="蜜蜂2"
        >
        <template slot-scope="scope"> 
           <div>{{ scope.row.bee2 }}</div>
           <div v-if="scope.row.bee2!=''&&!needhide">{{ scope.row.commission2 }}元/盒</div>
        </template>
      </el-table-column>


      <el-table-column
        label="蜜蜂3"
        >
        <template slot-scope="scope"> 
           <div>{{ scope.row.bee3 }}</div>
           <div v-if="scope.row.bee3!=''&&!needhide">{{ scope.row.commission3 }}元/盒</div>
        </template>
      </el-table-column>


      <el-table-column
        label="蜜蜂4"
        >
        <template slot-scope="scope"> 
           <div>{{ scope.row.bee4 }}</div>
           <div v-if="scope.row.bee4!=''&&!needhide">{{ scope.row.commission4 }}元/盒</div>
        </template>
      </el-table-column>


      <el-table-column
        label="状态"
        >
        <template slot-scope="scope"> 
          <div v-if="scope.row.ishandedit==1">
            <el-tag type="warning" >手动维护</el-tag>
          </div>
          <div v-else>
            <el-tag type="success" v-if="scope.row.matchtype==1||scope.row.matchtype==2">已匹配</el-tag>
            <el-tag type="info" v-else>未匹配</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
          <div v-if="scope.row.matchtype==0"><el-button type="primary" icon="el-icon-edit" @click="handleAdd(scope.row.drugcode,scope.row.drughospital)" size="small" >新增</el-button></div>
          <div v-else><el-button type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)" size="small" >编辑</el-button></div>

          <div><el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)" size="small">删除</el-button></div>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-tag type="info" plain>本页总数：{{pageTotalNums}}</el-tag>
        <el-tag type="warning" plain v-show="!needhide">本页总金额:{{ pageTotalMoney }}</el-tag>
        <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :page-sizes="[10, 50, 100,200,300,500]"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          @size-change="handleSizeChange"
          >
        </el-pagination>
      </div>

      <el-dialog
        title="下载历史数据源"
        :visible.sync="downSourceDialogVisible"
        >
        <el-alert
    title="温馨提醒：目前仅统计已经匹配过的数据，统计时间范围请尽量选择在12个月以内，以免数据量太大计算缓慢"
    type="error"  :closable="false">
  </el-alert>
        <div style='display:inline-block;'>
              <el-date-picker
              v-model="start_yearmonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="开始月份">
            </el-date-picker>
        </div>
        <div style='display:inline-block;'>
              <el-date-picker
              v-model="end_yearmonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="结束月份">
            </el-date-picker>
        </div>
        
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleDownSource('/download/downloadSourceDrug')">1、以药品汇总</el-button>
          <el-button type="primary" @click="handleDownSource('/download/downloadSourceHospital')">2、以医院汇总</el-button>
          <el-button type="primary" @click="handleDownSource('/download/downloadSource')">3、全部数据</el-button>
          <el-button type="danger" @click="downSourceDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="绑定小蜜蜂"
        :visible.sync="editSourceVisible"
        :fullscreen="true"
        >
        <EditSource :comdrugcode="curDrugcode" :comdrughospital="curDrughospital" v-if="editSourceVisible"/>
      </el-dialog>

      <el-dialog
        title="编辑单条数据源"
        :visible.sync="handEditVisible"
        
        >
        <el-alert
    title="请注意！修改过单条数据源后，此条记录之后将都只能手动维护，不受佣金配置自动匹配关联，请确保只在特殊情况，才对此数据源进行编辑！"
    type="error"  :closable="false">
  </el-alert>
          <el-descriptions title="" direction="vertical" :column="4" border>
          <el-descriptions-item label="日期">{{cureditrow.reporttime|timeToDate2}}</el-descriptions-item>
          <el-descriptions-item label="药厂">{{cureditrow.drugfactory}}</el-descriptions-item>
          <el-descriptions-item label="药名">{{cureditrow.drugname}}</el-descriptions-item>
          <el-descriptions-item label="规格">{{cureditrow.drugspec}}</el-descriptions-item>
          <el-descriptions-item label="销量" :span="2">{{cureditrow.nums}}</el-descriptions-item>
          <el-descriptions-item label="价格">{{cureditrow.price}}</el-descriptions-item>
          <el-descriptions-item label="医院">{{cureditrow.drughospital}}</el-descriptions-item>
        </el-descriptions>
        
        <el-form  label-width="180px" style="margin-top:30px;">
          <el-form-item label="小蜜蜂1" >
            <el-col :span="12">
              <el-select v-model="newbee1" filterable >
                <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-form-item label="小蜜蜂1佣金">
              <el-input v-model="newcom1"  placeholder="请输入佣金(元/盒)" ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
           
          <el-divider></el-divider>
          <el-form-item label="小蜜蜂2">
            <el-col :span="12">
              <el-select v-model="newbee2" filterable>
                <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-form-item label="小蜜蜂2佣金">
              <el-input v-model="newcom2"  placeholder="请输入佣金(元/盒)" ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-divider></el-divider>

          <el-form-item label="小蜜蜂3">
            <el-col :span="12">
              <el-select v-model="newbee3" filterable>
                <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-form-item label="小蜜蜂3佣金">
              <el-input v-model="newcom3"  placeholder="请输入佣金(元/盒)" ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-divider></el-divider>



          <el-form-item label="小蜜蜂4">
            <el-col :span="12">
              <el-select v-model="newbee4" filterable>
                <el-option v-for="item in userlist" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-form-item label="小蜜蜂4佣金">
              <el-input v-model="newcom4"  placeholder="请输入佣金(元/盒)" ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-divider></el-divider>


          <el-form-item>
          <el-button type="primary" @click="onSaveHandEdit" >确认保存</el-button>
        </el-form-item>
        </el-form>
      </el-dialog>

      <div v-if="loading" class="loadingcon">
        <i class="el-icon-loading"></i>执行匹配中，请稍后...
      </div>
   </div> 
</template>

<script>
import {downloadSource} from "../../api/index"
import EditSource from '../addbindbee/index.vue'
export default {
  data(){
     return {
        needhide:false,
        handEditVisible:false,
        cureditrow:{},
        newbee1:"",
        newbee2:"",
        newcom1:"",
        newcom2:"",


        newbee3:"",
        newbee4:"",
        newcom3:"",
        newcom4:"",

        userlist:[],

        downSourceDialogVisible:false,
        editSourceVisible:false,
        curDrugcode:'',
        curDrughospital:'',
        start_yearmonth:'',
        end_yearmonth:'',

        drughospital:'',
        drugfactory:'',
        drugsalecorp:'',
        drugname:'',
        drugcode:'',
        yearmonth:'',
        yearmonth2:'',
        matchtype:'',
        loading:false,

        hospitallist:[],
        factorylist:[],
        salecorplist:[],
        druglist:[],

        pageTotalNums:0,
        pageTotalMoney:0,

        processing:false,
        tableData:[],
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        }
     }
  },
  components:{
    EditSource
  },
  created(){
     this.getList()
  },
  methods: {
    onSaveHandEdit(){
      this.$post("/output/handEditSave",{row:this.cureditrow,newbee1:this.newbee1,newbee2:this.newbee2,newcom1:this.newcom1,newcom2:this.newcom2,newbee3:this.newbee3,newbee4:this.newbee4,newcom3:this.newcom3,newcom4:this.newcom4}).then((data)=>{
               if(data.result.success){
                this.$message({message:data.result.info,type:'success'})
                this.handEditVisible=false
                  setTimeout(()=>{this.getList()},500)
               }else{
                  this.$message.error(data.result.info)
               }
          })
    },
    handleEdit(rowdata){
       this.handEditVisible=true
       this.cureditrow=rowdata
       this.newbee1=rowdata["matchuserid"]
       this.newcom1=rowdata["commission1"]
       this.newbee2=rowdata["matchuserid2"]
       this.newcom2=rowdata["commission2"]

       this.newbee3=rowdata["matchuserid3"]
       this.newcom3=rowdata["commission3"]
       this.newbee4=rowdata["matchuserid4"]
       this.newcom4=rowdata["commission4"]

    },
    handleSizeChange(val){
       this.pageinfo.pagesize=val
       this.getList()
    },
    handleAdd(drugcode,drughospital){
        this.curDrugcode=drugcode
        this.curDrughospital=drughospital
        if(this.curDrugcode==""||this.curDrughospital==""){
          this.$message.error("内部参数有误");return false
        }
        this.editSourceVisible=true
    },
      getList(){
          this.$post("/output/getSourceList",{keywords:this.keywords,pageinfo:this.pageinfo,yearmonth:this.yearmonth,yearmonth2:this.yearmonth2,drugfactory:this.drugfactory,drugsalecorp:this.drugsalecorp,drughospital:this.drughospital,matchtype:this.matchtype,drugcode:this.drugcode}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.sourcelist
                  this.pageinfo=data.result.info.pageinfo 
                  this.factorylist=data.result.info.factorylist
                  this.hospitallist=data.result.info.hospitallist
                  this.salecorplist=data.result.info.salecorplist
                  this.druglist=data.result.info.druglist
                  this.yearmonth=data.result.info.yearmonth
                  this.yearmonth2=data.result.info.yearmonth2
                  this.userlist=data.result.info.userlist
                  this.pageTotalNums=data.result.info.pageTotalNums
                  this.pageTotalMoney=data.result.info.pageTotalMoney
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      batchDelete(){
        if(this.processing){
           this.$message.error("请等待处理完成");return false
        }
        

        this.$confirm('此操作将删除所有此次筛选查询的结果,共'+this.tableData.length+'条数据源记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.processing=true
            this.$post("/output/batchDelete",{list:this.tableData}).then((data)=>{
               this.processing=false
               if(data.result.success){
                  this.$message({message:data.result.info,type:'success'})
                  setTimeout(()=>{this.getList()},500)
               }else{
                  this.$message.error(data.result.info)
               }
            })
        }) 
        
      },
      goMatch(){
        if(this.processing){
           this.$message.error("请等待处理完成");return false
        }
        this.loading=true
        this.processing=true
        this.$post("/prize/refreshMath",{yearmonth:this.yearmonth,yearmonth2:this.yearmonth2,drugcode:this.drugcode,drugsalecorp:this.drugsalecorp}).then((data)=>{
               this.loading=false
               this.processing=false
               if(data.result.success){
                  this.$message({message:data.result.info,type:'success'})
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleDownSource(url){
          if(this.start_yearmonth==""||this.start_yearmonth==undefined){
              this.$message.error("请先选择开始年月");return false
          }
          if(this.end_yearmonth==""||this.end_yearmonth==undefined){
              this.$message.error("请先选择结束年月");return false
          }
          downloadSource(url,{mstart:this.start_yearmonth,mend:this.end_yearmonth}) 
      },
      handleDelete(id){
        this.$confirm('此操作将删除该条数据源记录,与之相关的奖励会发生变化, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.doDelete(id)
        }).catch(() => {
                     
        }); 
      },
      doDelete(id){
        if(this.processing){
           this.$message.error("请等待处理完成");return false
        }
        this.processing=true
        this.$post("/output/delSourceRecord",{id:id}).then((data)=>{
               this.processing=false
               if(data.result.success){
                  this.$message({message:data.result.info,type:'success'})
                  setTimeout(()=>{this.getList()},500)
               }else{
                  this.$message.error(data.result.info)
               }
        })
      }
  }
}
</script>

<style scoped lang="scss">
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
/deep/ .el-date-editor.el-input{width:120px!important;}
.loadingcon{
  position:fixed;
  left:0;
  top:0;
  width:100%;
  height:100vh;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
}
</style>
